import React, { useEffect, useState } from 'react';
import { getAllGalleries, deleteGallery, updateGallery } from '../../../services/operations/GALLARYAPI';
import { toast } from 'react-hot-toast';

const GalleryTable = () => {
    const [galleries, setGalleries] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [currentGallery, setCurrentGallery] = useState(null);
    const [title, setTitle] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await getAllGalleries();
                console.log("Fetched galleries:", result);  // Log the fetched data

                if (result?.success) {
                    setGalleries(result.galleries || []);  // Access galleries from result
                } else {
                    toast.error("Failed to load galleries");
                }
            } catch (error) {
                console.error("Error fetching galleries:", error);
                toast.error("An error occurred while fetching galleries");
            }
        };
        fetchData();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this gallery?")) {
            try {
                const result = await deleteGallery(id);
                if (result?.success) {
                   
                    setGalleries(galleries.filter((gallery) => gallery._id !== id));
                } else {
                    toast.error("Failed to delete gallery");
                }
            } catch (error) {
                console.error("Error deleting gallery:", error);
                toast.error("An error occurred while deleting the gallery");
            }
        }
    };

    const handleEdit = (gallery) => {
        setCurrentGallery(gallery);
        setTitle(gallery.title);
        setEditMode(true);
    };

    const handleUpdate = async () => {
        try {
            const result = await updateGallery(currentGallery._id, { title });
            if (result?.success) {
               
                setGalleries(galleries.map(gallery =>
                    gallery._id === currentGallery._id ? { ...gallery, title } : gallery
                ));
                setEditMode(false);
                setCurrentGallery(null);
            } else {
                toast.error("Failed to update gallery");
            }
        } catch (error) {
            console.error("Error updating gallery:", error);
            toast.error("An error occurred while updating the gallery");
        }
    };

    return (
        <div className="overflow-x-auto">
            {editMode && currentGallery && (
                <div className="fixed inset-0 bg-gray-700 bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded shadow-lg w-1/3">
                        <h2 className="text-xl mb-4">Edit Gallery</h2>
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            className="border border-gray-300 rounded w-full p-2 mb-4"
                            placeholder="Title"
                        />
                        <div className="flex justify-end">
                            <button
                                onClick={handleUpdate}
                                className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
                            >
                                Save
                            </button>
                            <button
                                onClick={() => setEditMode(false)}
                                className="bg-gray-500 text-white px-4 py-2 rounded"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <table className="min-w-full bg-white border border-gray-200">
                <thead>
                    <tr>
                        <th className="py-2 px-4 border-b">Image</th>
                        <th className="py-2 px-4 border-b">Title</th>
                        <th className="py-2 px-4 border-b">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(galleries) && galleries.length > 0 ? (
                        galleries.map((gallery) => (
                            <tr key={gallery._id}>
                                <td className="py-2 px-4 border-b">
                                    {gallery?.images && gallery.images.length > 0 ? (
                                        <img src={gallery.images[0]?.url} alt={gallery?.title} className="w-16 h-16 object-cover" />
                                    ) : (
                                        <span>No Image</span>
                                    )}
                                </td>
                                <td className="py-2 px-4 border-b">{gallery?.title}</td>
                                <td className="py-2 px-4 border-b">
                                    <button
                                        onClick={() => handleEdit(gallery)}
                                        className="text-blue-600 hover:underline mr-2"
                                    >
                                        Edit
                                    </button>
                                    <button
                                        onClick={() => handleDelete(gallery._id)}
                                        className="text-red-600 hover:underline"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" className="text-center py-4">No galleries found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default GalleryTable;
